module.exports = __webpack_public_path__ + "static/media/Vice mayor Speech.b6685469.mp4";